"use client";

import { Link as ScrollLink } from "react-scroll";
import NextLink from "next/link";
import { usePathname } from "next/navigation";

const ContactButton = ({ className }: { className?: string }) => {
  const pathname = usePathname();

  // If on a post (different page), navigate to home with hash using Next.js Link
  if (pathname !== "/") {
    return (
      <NextLink href="/#ContactForm" className={`nav-link ${className}`}>
        Contact
      </NextLink>
    );
  }

  // Otherwise, perform an on-page smooth scroll
  return (
    <ScrollLink
      to="ContactForm"
      smooth={true}
      className={`nav-link ${className}`}
    >
      Contact
    </ScrollLink>
  );
};

export default ContactButton;
